export const SET_BENEFITS = "setBenefits";
export const SET_BENEFIT = "setBenefit";
export const BENEFITS_RESET = "benefitsReset";
export const BENEFIT_RESET = "benefitReset";
export const BENEFIT_RESET_STATE = "benefitResetState";
export const SET_BENEFIT_PAGINATION = "setBenefitPagination"
export const SET_BENEFIT_ACTIVE = "setBenefitActive"